export default class ItemEachPage {
  constructor() {
    this.bindQuickSubmit()
  }

  buildUrlWithEachPage(eachPage) {
    const url = new URL(window.location.href)
    url.searchParams.set('items_each_page', eachPage)
    url.searchParams.delete('page')
    return url
  }

  syncEachPageState(eachPage) {
    $("input[name='items_each_page']").val(eachPage)
    $('.select-items-each-page, .show-number-of-page-js').each((_, element) => {
      element.textContent = eachPage
    })

    $('.filter-content-number-record .option, .filter-content-number-record-task .option, #itemOfPage .option').removeClass('slted')
    $(`.filter-content-number-record .option, .filter-content-number-record-task .option, #itemOfPage .option`).filter((_, element) => {
      return $(element).text().trim() === `${eachPage}`
    }).addClass('slted')
  }

  selectEachPage(element, eachPage) {
    const container = element.closest('.filter-content')
    this.syncEachPageState(eachPage)

    if (!container || !container.querySelector('.quick-submit')) {
      this.changeEachPage(eachPage)
      return
    }

    container.dataset.itemsEachPage = eachPage
    $(container).find('.option').removeClass('slted')
    $(element).addClass('slted')
  }

  bindQuickSubmit() {
    document.addEventListener('click', (event) => {
      const submitButton = event.target.closest(
        '.filter-content-number-record .quick-submit, .filter-content-number-record-task .quick-submit'
      )
      if (!submitButton) return

      const container = submitButton.closest('.filter-content')
      const eachPage =
        container?.dataset.itemsEachPage ||
        container?.querySelector('.option.slted')?.textContent?.trim() ||
        container?.closest('form')?.querySelector("input[name='items_each_page']")?.value ||
        $("input[name='items_each_page']").first().val()

      if (!eachPage) return

      event.preventDefault()
      event.stopPropagation()
      this.syncEachPageState(eachPage)
      window.location.assign(this.buildUrlWithEachPage(eachPage).toString())
    }, true)
  }

  change(ele) {
    const eachPage = $(ele).val()
    this.syncEachPageState(eachPage)
    window.location.assign(this.buildUrlWithEachPage(eachPage).toString())
  }

  changeEachPage(eachPage) {
    this.syncEachPageState(eachPage)
    window.location.assign(this.buildUrlWithEachPage(eachPage).toString())
  }
}
